export default {"src":"/_next/static/media/BAFN.45b818b3.svg","height":18,"width":18};